import React from 'react';
import styles from './index.module.scss'

interface InputNameProps{
    getTitle: (title: string) => void
    value: string
    hasError?: boolean
    describedBy?: string
}

export default function InputName({ getTitle, value, hasError = false, describedBy }: InputNameProps){
    return (
        <input type="text"
               placeholder={"Введите название"}
               className={`${styles.inputName} ${value.trim() ? styles.inputNameActive : ''} ${hasError ? styles.inputNameError : ''}`}
               value={value}
               aria-invalid={hasError}
               aria-describedby={hasError ? describedBy : undefined}
               onChange={e => getTitle(e.target.value)}/>
    )
}
